import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Floor from '../entities/floor'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface FloorState extends ListState<Floor>{
    editFloor:Floor
}
class UserMutations extends ListMutations<Floor>{

}
class FloorModule extends ListModule<FloorState,any,Floor>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Floor>(),
        filterlist:new Array<Floor>(),
        loading:false,
        editFloor:new Floor()
    }
    actions={
        async getAll(context:ActionContext<FloorState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Floor/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Floor>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async RegetAll(context:ActionContext<FloorState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Floor/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Floor>;
            context.state.totalCount=page.totalCount;
            // context.state.list=page.items;
            // context.state.filterlist=page.items;
            return page.items;
        },
        async getPaged(context:ActionContext<FloorState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Floor/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Floor>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<FloorState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Floor/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Floor>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<FloorState,any>,payload:any){
            await Ajax.post('/api/services/app/Floor/Create',payload.data);
        },
        async update(context:ActionContext<FloorState,any>,payload:any){
            await Ajax.put('/api/services/app/Floor/Update',payload.data);
        },
        async delete(context:ActionContext<FloorState,any>,payload:any){
            await Ajax.delete('/api/services/app/Floor/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<FloorState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Floor/GetById?Id='+payload.id);
            return reponse.data.result as Floor;
        }
    };
    mutations={
        setCurrentPage(state:FloorState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:FloorState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:FloorState,floor:Floor){
            
            state.editFloor=floor;
            //console.log(state.editFloor);
        }
    }
}
const floorModule=new FloorModule();
export default floorModule;